/**
 * Utility functions for handling API calls with proxy path prefix
 */

/**
 * Get the API base URL with proper prefix
 */
export const getApiBaseUrl = (): string => {
  return "/__BASE_PATH__/api";
};

/**
 * Build full API URL with proper prefix
 */
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiBaseUrl();
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};
